export declare const ToCenterScroll: any;
export default ToCenterScroll;
export * from './src/center-scroll';
